export default __webpack_public_path__ + "static/media/avatar.5e76d971.svg";